import { DOCUMENT, isPlatformBrowser } from '@angular/common';
import { Component, OnInit, HostListener, Inject, Optional, PLATFORM_ID } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { Location } from '@angular/common';
import { DeviceDetectorService } from 'ngx-device-detector';
import { AppService } from './shared/services/app.service';
import * as AOS from 'aos';
import { filter } from 'rxjs';
import { SeoService } from './shared/services/seo.service';
import { SSR_IS_MOBILE } from './shared/constants/device.constants';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
    hideHeader = false;
    hideFooter = false;
    constructor(
        private location: Location,
        protected deviceService: DeviceDetectorService,
        private appservice: AppService,
        private activatedRoute: ActivatedRoute,
        private router: Router,
        @Inject(PLATFORM_ID) private platformId: object,
        private seoService: SeoService,
        @Inject(DOCUMENT) private document: Document,
        @Optional() @Inject(SSR_IS_MOBILE) private ssrIsMobile: boolean
    ) {
        this.deviceService.isMobile = () => {
            return isPlatformBrowser(this.platformId)
                ? window.innerWidth < 992
                : this.ssrIsMobile ?? false;
        };
        this.deviceService.isDesktop = () => {
            return !this.deviceService.isMobile();
        }
        this.activatedRoute.queryParams.subscribe((params: any) => {
            if(params.utm_campaign) {
                this.getAppConfig(params);
            }
        });
        this.router.events
        .pipe(filter(event => event instanceof NavigationEnd))
        .subscribe(() => {
            this.updateHeaderFooterStatus();
            this.updateSeo();
        });
        this.updateHeaderFooterStatus();
        this.updateSeo();
    }

    updateHeaderFooterStatus() {
        const {hideHeader = false, hideFooter = false } = this.activatedRoute.snapshot.firstChild.data;
        this.hideHeader = hideHeader;
        this.hideFooter = hideFooter;
    }

    private updateSeo() {
        const route = this.activatedRoute.snapshot.firstChild;
        if (route) this.seoService.update(route, this.router.url);
    }

    @HostListener('window:resize', ['$event'])
    onResize() {
        if (!isPlatformBrowser(this.platformId)) return;
        const isDesktop = this.deviceService.isDesktop(), bodyTag = document.getElementsByTagName('body')[0];
        bodyTag.className = `${isDesktop ? 'desktop-device' : 'mobile-device'}`;
    }

    ngOnInit() {
        this.setDeviceClass();
        if (!isPlatformBrowser(this.platformId)) return;
        const ua = window.navigator.userAgent;
        const trident = ua.indexOf('Trident/');
        let version = null;
        if (trident > 0) {
            // IE 11 => return version number
            const rv = ua.indexOf('rv:');
            version = parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10);
        }
        if (version) {
            const body = document.getElementsByTagName('body')[0];
            if(body) body.classList.add('ie-background');
        }
        AOS.init({
            duration: 1500,
            once: false, // whether animation should happen only once - while scrolling down
            mirror: true, // whether elements should animate out while scrolling past them
		});
    }

    private setDeviceClass() {
        const body = this.document.body;
        if (body) body.className = this.deviceService.isMobile() ? 'mobile-device' : 'desktop-device';
    }

    isHideFooter() {
        let title = this.location.prepareExternalUrl(this.location.path());
        title = title.slice(1);
        return ['sign-up', 'nucleoicons'].includes(title);
    }

    getRoute() {
        return this.location.prepareExternalUrl(this.location.path()).slice(1);
    }

    getAppConfig(params) {
        this.appservice.getAppConfig(params).then(resp => {});
    }
}